import { Injectable, inject } from "@angular/core";
import { LorenAssetTraceEndpointsService } from "../loren-asset-trace-endpoints/loren-asset-trace-endpoints.service";
import { GenericItems } from "../../../../shared/interfaces/generic-items.interface";
import { Observable } from "rxjs";
import { LorenTrace } from "../../interfaces/loren-trace.interface";
import { HttpClient } from "@angular/common/http";
import { Instant } from "@js-joda/core";

@Injectable({ providedIn: "root" })
export class LorenAssetTraceService {
  private http = inject(HttpClient);
  private endpointsService = inject(LorenAssetTraceEndpointsService);

   getAssetTraces(
    meteringId: number,
    fromDate: Instant,
    toDate: Instant,
    order: "asc" | "desc" = "asc",
    distance: number = null
  ): Observable<GenericItems<LorenTrace>> {
    return this.http.get<GenericItems<LorenTrace>>(
      this.endpointsService.getAssetTraces(
        meteringId,
        fromDate,
        toDate,
        order,
        distance
      ),
      {}
    );
  }

  exportTraceStopsDistanceSelectionReport(
    meteringIds,
    dateFrom,
    dateTo,
    stopDistanceCriteria
  ) {
    const url = this.endpointsService.exportTraceStopsDistanceSelectionReport(
      meteringIds,
      dateFrom,
      dateTo,
      stopDistanceCriteria
    );
    return this.http.get(url, { responseType: 'blob' });
  }
}
